import React from 'react'
import classNames from 'classnames'
import styles from './PurchaseForm.module.css'
import {BlockBase} from '../base'

interface StepProps {
  showing: boolean
  children: JSX.Element
  verticalAlignment: 'start' | 'center' | 'end'
  padding: BlockBase['padding']
  border: BlockBase['border']
}

export default function Step(props: StepProps) {
  const {showing, verticalAlignment, children} = props

  return (
    <div
      className={styles.stepBox}
      style={{
        opacity: showing ? 1 : 0,
        visibility: showing ? 'visible' : 'hidden',
        alignItems: verticalAlignment,
      }}
    >
      <div
        className={classNames({
          'block-content': showing,
        })}
        style={{
          width: '100%',
        }}
      >
        {children}
      </div>
    </div>
  )
}
